import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Image } from '@daedalus/atlas/Image';
import { ScoreRatingLoader } from '@daedalus/atlas/ScoreRating';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { StarRating } from '@daedalus/atlas/StarRating';
import { Text } from '@daedalus/atlas/Text';
import { ImageProvider } from '@daedalus/core/src/staticContent/types/ImageProvider';
import { ContentHotel, Hotel } from '@findhotel/sapi';
import { ReviewRating } from '../ReviewRating';
const GalleryWrapper = /*#__PURE__*/styled('div')({
  name: "GalleryWrapper",
  class: "gkh5pch",
  propsAsIs: false
});
const PlaceholderImageElement = /*#__PURE__*/styled('img')({
  name: "PlaceholderImageElement",
  class: "p3gwdar",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => Flex.Column;
const ContentWrapper = /*#__PURE__*/styled(_exp4())({
  name: "ContentWrapper",
  class: "ccrj9k6",
  propsAsIs: true
});
const _exp8 = /*#__PURE__*/() => Flex.Row;
const StarsWrapper = /*#__PURE__*/styled(_exp8())({
  name: "StarsWrapper",
  class: "s101wo5b",
  propsAsIs: true
});
const _exp10 = /*#__PURE__*/() => Text;
const HotelName = /*#__PURE__*/styled(_exp10())({
  name: "HotelName",
  class: "hwvoj54",
  propsAsIs: true
});
const PriceWrapper = /*#__PURE__*/styled('div')({
  name: "PriceWrapper",
  class: "p1p7r1uk",
  propsAsIs: false
});
const Grid = /*#__PURE__*/styled('div')({
  name: "Grid",
  class: "g1fz9htj",
  propsAsIs: false
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w15gbi60",
  propsAsIs: false
});
const ReviewSentimentsWrapper = /*#__PURE__*/styled('div')({
  name: "ReviewSentimentsWrapper",
  class: "r1jffhsl",
  propsAsIs: false
});
const TopLeftSlotWrapper = /*#__PURE__*/styled('div')({
  name: "TopLeftSlotWrapper",
  class: "tjzl1ml",
  propsAsIs: false
});
export interface HotelCardCondensedProps {
  isPopper?: boolean;
  hotel: Hotel | ContentHotel;
  priceSlot?: React.ReactNode;
  topLeftSlot?: React.ReactNode;
  topRightSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
  informationSlot?: React.ReactNode;
  imageProviderInstance: ImageProvider;
  placeHolderImage: string;
  isLoading?: boolean;
  hasBorder?: boolean;
  cashbackSlot?: React.ReactNode;
}
const HotelCardCondensedLoader = ({
  placeHolderImage
}: Pick<HotelCardCondensedProps, 'placeHolderImage'>) => {
  return <Wrapper>
      <GalleryWrapper data-id={'Image'}>
        <PlaceholderImageElement src={placeHolderImage} alt="placeholder" />
      </GalleryWrapper>
      <ContentWrapper>
        <StarsWrapper justifyContent="space-between" alignItems="center">
          <SkeletonLoader width={70} height={12} />
        </StarsWrapper>
        <HotelName data-id="HotelName">
          <SkeletonLoader width={120} height={24} />
        </HotelName>
        <ScoreRatingLoader />
        <ReviewSentimentsWrapper>
          <SkeletonLoader width={196} height={16} />
        </ReviewSentimentsWrapper>
        <PriceWrapper>
          <SkeletonLoader width={80} height={32} />
        </PriceWrapper>
      </ContentWrapper>
    </Wrapper>;
};
export const HotelCardCondensed = ({
  imageProviderInstance,
  hotel,
  hasBorder,
  priceSlot,
  topLeftSlot,
  topRightSlot,
  bottomSlot,
  isPopper,
  informationSlot,
  placeHolderImage,
  isLoading,
  cashbackSlot
}: HotelCardCondensedProps) => {
  const {
    isMobile
  } = useDeviceLayout();
  const galleryImageURL = hotel?.imageURIs?.[0];
  return isLoading ? <HotelCardCondensedLoader placeHolderImage={placeHolderImage} /> : <Wrapper className={cx(hasBorder && 'hasBorder')} data-id="hotelCardTooltip">
      <Grid className={cx(isPopper && 'isPopper')}>
        <GalleryWrapper className={cx(!!bottomSlot && 'hasBottomContent')} data-id={'Image'}>
          <Image fullWidth isResponsive imageProvider={imageProviderInstance} size={isMobile ? 'mobileLarge' : 'extraLarge'} url={galleryImageURL} backgroundSize="cover" hasSkeletonLoader placeHolderImage={placeHolderImage} />
        </GalleryWrapper>
        <ContentWrapper>
          <StarsWrapper justifyContent="space-between" alignItems="center">
            <StarRating data-id="starRating" rating={hotel.starRating as number} size="xs" />
            {topRightSlot}
          </StarsWrapper>
          <HotelName dataId="HotelName" variant="titleM" colorPath="content.neutral.c800" className={cx(!!topRightSlot && 'hasPadding')}>
            {hotel.hotelName}
          </HotelName>
          <ReviewRating rating={hotel.guestRating?.overall} totalRatingCount={hotel.reviewCount} hotelId={hotel.objectID} variant="compact" />
          <ReviewSentimentsWrapper>
            {informationSlot && informationSlot}
          </ReviewSentimentsWrapper>
          {priceSlot && <PriceWrapper>{priceSlot}</PriceWrapper>}
          {cashbackSlot && cashbackSlot}
        </ContentWrapper>
        {topLeftSlot && <TopLeftSlotWrapper>{topLeftSlot}</TopLeftSlotWrapper>}
      </Grid>
      {bottomSlot}
    </Wrapper>;
};

require("./HotelCardCondensed.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HotelCardCondensed.tsx");